module.exports = __webpack_public_path__ + "static/media/pie.241ba99c.svg";